import type { DriveStep } from 'driver.js'

export const analyticsTour: Array<DriveStep> = [
  {
    element: '#usage-chart',
    popover: {
      title: 'Request Volume',
      description:
        'Track total requests over time. Filter by date range, model, or API key to analyze usage patterns.',
      side: 'bottom',
    },
  },
  {
    element: '#token-breakdown',
    popover: {
      title: 'Token Usage by Model',
      description:
        'See which models consume the most tokens. Optimize costs by switching to cheaper alternatives for similar tasks.',
      side: 'top',
    },
  },
  {
    element: '#cost-tracker',
    popover: {
      title: 'Cost Analysis',
      description:
        'Real-time cost tracking with provider-level breakdown. Understand where your budget goes and identify optimization opportunities.',
      side: 'left',
    },
  },
  {
    element: '#export-data',
    popover: {
      title: 'Export Reports',
      description:
        'Download CSV/JSON reports for accounting, auditing, or further analysis in your preferred tools.',
      side: 'top',
    },
  },
]
